import './index.scss'
import logoIcon from '../../assets/img/logo.svg';
// import MyNavLink from '../MyNavLink'

import SelectChain from '../SelectChain'

export default function Header() {
    // let navList = [
    //    { to:'/Arbitrum',title:'Arbitrum'},
    // ]

    return (
        <div className="App-header-nav">
            <a href="https://www.yfx.com" target="_blank" rel="noopener noreferrer"><img className="yfx-logo" src={logoIcon} alt="YFX Logo"/></a>
            <div>
                <a href="https://docs.yfx.com/" target="_blank" rel="noopener noreferrer">Docs</a>
                <a className='launch-app' href="https://app.yfx.com" target="_blank" rel="noopener noreferrer" >Launch App</a>
                <SelectChain />
            </div>

            {/* {
                navList.map((item,index)=>{
                    return <MyNavLink className="nav-link" key={index} to={item.to}>{item.title}</MyNavLink>
                })
            } */}
        </div>
    )
   
}

